<template>
	<div class="">
		<b-modal
			:id="modalId"
			ref="modalAlert"
			modal-class="modal-platform"
			size="sm"
			centered
			hide-header
			hide-footer
		>
				<b-row class="text-dark-9 mb-2">
					<b-col>File is not following our recommendation</b-col>
				</b-row>
				<b-row class="text-dark-8 text-s-s mb-3">
					<b-col>Your stream may be unstable. We recommend you to encode your file following <a target="_blank" class="text-reset text-underline" href="https://docs.castr.com/en/articles/5161326-recommended-settings-for-recorded-videos">our guide</a>. If you still want to use the current file, kindly do a test stream before the actual livestream.</b-col>
				</b-row>
				<b-row>
					<b-col :class="buttonAlignment">
						<b-button
							variant="outline-secondary"
							size="md"
							class="ml-auto"
							@click="dismiss"
						>
							Cancel
						</b-button>
						<b-button
							variant="primary"
							size="md"
							class="ml-2"
							@click="onConfirm"
						>
							{{ okText }}
						</b-button>
					</b-col>
				</b-row>
		</b-modal>
	</div>
</template>

<script>
export default {
	name: 'UploadAlertBadFormatModal',
	components: {},
	props: {
		modalId: {
			type: String,
			default: 'modal-alert'
		},
		okText: {
			type: String,
			default: 'Yes'
		},
		buttonAlignment: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			processing: false
		};
	},
	methods: {
		onConfirm() {
			this.$emit('modal-confirm');
			this.dismiss();
		},
		dismiss() {
			this.$refs.modalAlert.hide();
			// lazy clear
			setTimeout(() => { this.processing = false; }, 1000);
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-button {
  border: none;
  padding: 7px 30px;
  font-size: 15.5px;
  color: #f7f7f7;
  background-color: transparent;
  text-transform: capitalize;
  font-size: 13.5px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  border-radius: 50px;
  outline: none;
}
.modal-button:hover {
  background-color: rgba(0, 98, 255, 0.425);
}
.modal-button:active {
  background-color: rgba(0, 98, 255, 0.7);
}
.modal-button.highlight {
  background-color: #0062ff;
}
.modal-button.highlight:hover {
  background-color: #001aff
}
</style>
